/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConnectResponse,
  ConnectionInfoRequest,
  ConnectionStatus,
  DisconnectResult,
  MapString,
  SettingsCreateRequest,
  SettingsResponse,
  SettingsUpdateRequest,
  Tuple2TypeConnectionStatus,
  ZoomUser,
  ZoomUsers,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "zoom";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Initiates OAuth authorization flow to connect a user to Zoom
   *
   * @name ConnectAUserToZoom
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/connect
   * @secure
   */
  connectAUserToZoom = (
    tenantId: string,
    userId: string,
    query: {
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ConnectResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/connect`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for connectAUserToZoom */
  connectAUserToZoomPathGetter = (
    tenantId: string,
    userId: string,
    query: {
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/connect`, query);

  /**
   * @description Disconnects a user from Zoom if is connected
   *
   * @name DisconnectAUserFromZoom
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/disconnect
   * @secure
   */
  disconnectAUserFromZoom = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      DisconnectResult,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/disconnect`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for disconnectAUserFromZoom */
  disconnectAUserFromZoomPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/disconnect`);

  /**
   * @description Requests zoom status (active/pending/inactive) about a given user
   *
   * @name GetInfoAboutAUser
   * @request GET:/v1/tenant/{tenantId}/user/{userId}
   * @secure
   */
  getInfoAboutAUser = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      ZoomUser,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getInfoAboutAUser */
  getInfoAboutAUserPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}`);

  /**
   * @description Requests about all users's zoom statuses (active/pending/inactive) of a given tenant
   *
   * @name GetInfoAboutAllUsersOfATenant
   * @request POST:/v1/tenant/{tenantId}/status/list
   * @secure
   */
  getInfoAboutAllUsersOfATenant = (tenantId: string, data: ConnectionInfoRequest, params: RequestParams = {}) =>
    this.request<
      ZoomUsers,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/status/list`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getInfoAboutAllUsersOfATenant */
  getInfoAboutAllUsersOfATenantPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/status/list`);

  /**
   * @description Requests connection details about a given user
   *
   * @name GetInfoAboutAUsersConnectionStatus
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/connectionStatus
   * @secure
   */
  getInfoAboutAUsersConnectionStatus = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      ConnectionStatus,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/connectionStatus`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getInfoAboutAUsersConnectionStatus */
  getInfoAboutAUsersConnectionStatusPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/connectionStatus`);

  /**
   * @description Requests connection details about all users in tenant
   *
   * @name GetInfoAboutAllUsersConnectionStatusesInTenant
   * @request GET:/v1/tenant/{tenantId}/connectionStatuses
   * @secure
   */
  getInfoAboutAllUsersConnectionStatusesInTenant = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      Tuple2TypeConnectionStatus[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/connectionStatuses`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getInfoAboutAllUsersConnectionStatusesInTenant */
  getInfoAboutAllUsersConnectionStatusesInTenantPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/connectionStatuses`);

  /**
   * @description Find the zoom organization settings for a given tenant
   *
   * @tags Zoom, Zoom Settings, Organization Settings, User Authenticated, v1
   * @name FindZoomOrganizationSettings
   * @request GET:/v1/tenant/{tenantId}/settings
   * @secure
   */
  findZoomOrganizationSettings = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SettingsResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findZoomOrganizationSettings */
  findZoomOrganizationSettingsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/settings`);

  /**
   * @description Update the zoom organization settings for a given tenant
   *
   * @tags Zoom, Zoom Settings, Organization Settings, User Authenticated, v1
   * @name UpdateZoomOrganizationSettings
   * @request PUT:/v1/tenant/{tenantId}/settings
   * @secure
   */
  updateZoomOrganizationSettings = (tenantId: string, data: SettingsUpdateRequest, params: RequestParams = {}) =>
    this.request<
      SettingsResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/settings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateZoomOrganizationSettings */
  updateZoomOrganizationSettingsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/settings`);

  /**
   * @description Creates the zoom organization settings for a given tenant
   *
   * @tags Zoom, Zoom Settings, Organization Settings, User Authenticated, v1
   * @name CreateZoomOrganizationSettings
   * @request POST:/v1/tenant/{tenantId}/settings
   * @secure
   */
  createZoomOrganizationSettings = (tenantId: string, data: SettingsCreateRequest, params: RequestParams = {}) =>
    this.request<
      SettingsResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/settings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createZoomOrganizationSettings */
  createZoomOrganizationSettingsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/settings`);

  /**
   * @description Update the zoom organization settings for a given tenant
   *
   * @tags Zoom, Zoom Settings, Organization Settings, User Authenticated, v1
   * @name UpdateZoomOrganizationSettings2
   * @request DELETE:/v1/tenant/{tenantId}/settings
   * @originalName updateZoomOrganizationSettings
   * @duplicate
   * @secure
   */
  updateZoomOrganizationSettings2 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SettingsResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/settings`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateZoomOrganizationSettings2 */
  updateZoomOrganizationSettings2PathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/settings`);

  /**
   * No description
   *
   * @name ReceivesCallbacksFromZoomOnAuthorizationRequestCompletion
   * @request GET:/v1/public/oauth/callback
   */
  receivesCallbacksFromZoomOnAuthorizationRequestCompletion = (
    query: {
      /**
       * Authorization code to be used to get an access token
       * @minLength 1
       */
      code: string;
      /**
       * OAuth state with flow metadata
       * @minLength 1
       */
      state: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      any,
      | void
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/oauth/callback`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Returns string containing request path for receivesCallbacksFromZoomOnAuthorizationRequestCompletion */
  receivesCallbacksFromZoomOnAuthorizationRequestCompletionPathGetter = (query: {
    /**
     * Authorization code to be used to get an access token
     * @minLength 1
     */
    code: string;
    /**
     * OAuth state with flow metadata
     * @minLength 1
     */
    state: string;
  }) => this.getServicePath(`/v1/public/oauth/callback`, query);
}
